export const ITEMS_PER_PAGE_KEY = {
  PROJECT_LIST: 'projectList',
  VERIFICATION_REPORT_LIST: 'verificationReportList',
  NOTICE_INFORMATION_LIST: 'noticeInformationList',
  SBOM_MERGE_LIST: 'sbomMergeList',
  PREVIEW_LIST: 'previewList',
  REQUEST_LIST: 'requestList',
  IMPORTED_COMPONENT_LIST: 'importedComponentList',
  COMPONENT_LIST: 'componentList',
  LICENSE_LIST: 'licenseList',
  VULNERABILITY_STATUS: 'vulnerabilityStatus',
  CVE_STATUS: 'cveStatus',
  CVE_ANALYSIS: 'cveAnalysis',
  COMPONENT_USAGE_STATUS: 'componentUsageStatus',
  LICENSE_USAGE_STATUS: 'licenseUsageStatus',
  COMPONENT_INFO_TABLE: 'componentInfoTable',
  LICENSE_INFO_TABLE: 'licenseInfoTable',
  ASSET_CLASSIFICATION_LIST: 'assetClassificationList',
  ANNOUNCEMENT_LIST: 'announcementList',
  QA_LIST: 'qaList',
  FAQ_LIST: 'faqList',
  ARCHIVE_LIST: 'archiveList',
  USER_LIST: 'userList',
  SBOM_LIST: 'sbomList',
  PRODUCT_LIST: 'productList',
  MEMBER_SELECT_LIST: 'memberSelectList',
  ADD_VERIFICATION_REPORT_LIST: 'addVerificationReportList',
  ADD_VERIFICATION_SBOM_MERGE_LIST: 'addVerificationSbomMergeList',
  SELECT_VERIFICATION_RESULT_COMPARISON_LIST: 'selectVerificationResultComparisonList',
  DOWNLOAD_VERIFICATION_REPORT_SELECT_SBOM_LIST: 'downloadVerificationReportSelectSbomList',
  PREVIEW_LIST_ADD_COMPONENT_LIST: 'previewListAddComponentList',
  COMPONENT_TABLE_LIST: 'componentTableList',
  PREVIEW_COMPONENT_LIST: 'previewComponentList',
  PREVIEW_SELECTION_MODAL: 'previewSelectionModal',
  PRODUCT_DETAIL_PROJECT_LIST: 'productDetailProjectList',
  PRODUCT_DETAIL_MEMBER_LIST: 'productDetailMemberList',
  VERIFICATION_COMPARISONINFO_PREVIEW_LIST: 'verificationComparisoninfoPreviewList',
  VERIFICATION_COMPARISONINFO_PROJECT_LIST: 'verificationComparisoninfoProjectList',
  LICENSE_SELECTION_MODAL: 'licenseSelectionModal',
  PRODUCT_GROUP_TABLE_ITEM_LIST: 'productGroupTableItemList',
  WORK_HISTORY_LIST: 'workHistoryList',
  ROLE_LIST: 'roleList',
  IMPORT_HISTORY_LIST: 'importHistoryList',
  NOTICE_INFORMATION_VIEW_LIST: 'noticeInformationViewList',
  PRODUCT_PROJECTS_LIST: 'productProjectsList',
  SECURITY_INFORMATION_MODAL: 'securityInformationModal',
  FULFILLMENT_INFO_LIST: 'fulfillmentInfoList',
};

export const DEFAULT_ITEMS_PER_PAGE = 10;